// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface ISnippet {
  description: string;
  prefix: string[];
  body: string[];
}
